export const LogMutations = {
  cleanLogs (state) { state.logs = [] },
  setArchives (state, value) { state.archives = value },
  setLogs (state, value) { state.logs = value },
  setLogsActors (state, value) { state.logsActors = value },
}
